import { Button, Form, Input } from 'antd';
import { StyledForm } from './style';
import { _FORM_ITEM_LAYOUT, _TAIL_FORM_ITEM_LAYOUT } from '../../../constants';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const FirstMenstruationCycleForm = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);

  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log('Received values of form: ', values);
  };
  return (
    <StyledForm
      {..._FORM_ITEM_LAYOUT}
      form={form}
      name="first_menstruation_cycle_form"
      onFinish={onFinish}
      initialValues={{}}
      style={{ marginTop: '1rem' }}
      scrollToFirstError
    >
      <Form.Item {..._TAIL_FORM_ITEM_LAYOUT}>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </StyledForm>
  )
};

export default FirstMenstruationCycleForm;
